<template>
  <article class="live-comment" ref="wrapper">
    <header class="comment-header-wrapper" v-if="showHeader" ref="header">
      <h2>{{$t('comment.title')}}</h2>
    </header>
    <section class="comment-container-wrapper">
      <comment-container :roomId="roomId" :height="containerHeight" />
    </section>
    <footer class="comment-sender-wrapper" v-if="showSender" ref="sender">
      <comment-sender @login="onLogin" :mid="mid" :roomId="roomId" />
    </footer>
  </article>
</template>

<script>
import { defineComponent, ref, onMounted, onBeforeUnmount, computed } from 'vue';
import CommentSender from './comment-sender.vue';
import CommentContainer from './comment-container.vue';
import emitter, { EB_EVENT_NAME } from '@/utils/eventbus';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    showSender: {
      type: Boolean,
      default: true,
    },
    onLogin: {
      type: Function,
      default: () => {
      },
    },
  },
  components: {
    CommentSender,
    CommentContainer,
  },
  setup(props) {
    const wrapper = ref(null);
    const header = ref(null);
    const sender = ref(null);
    const containerHeight = ref('100px');

    const store = useStore();
    const mid = computed(() => store.state.global.userInfo?.mid);
    const roomId = computed(() => store.state.room.roomInfo?.room_id);

    // 获取容器高度
    const getContainerHeight = async () => {
      const wrapperHeight = wrapper.value.offsetHeight;
      const senderHeight = props.showSender ? sender.value.offsetHeight : 0;
      const headerHeight = props.showHeader ? header.value.offsetHeight : 0;
      const newHeight = `${wrapperHeight - senderHeight - headerHeight}px`;
      if (newHeight !== containerHeight.value) {
        containerHeight.value = newHeight;
      }
    };

    // dom节点监听，主要是因为textarea无法自适应变高
    const senderObserver = new MutationObserver(async () => {
      await getContainerHeight();
      emitter.emit(EB_EVENT_NAME.COMMENTS_CONTAINER_RESIZED);
    });

    const wrapperObserver = new MutationObserver(async () => {
      await getContainerHeight();
      emitter.emit(EB_EVENT_NAME.COMMENTS_CONTAINER_RESIZED);
    });

    onMounted(() => {
      getContainerHeight();
      window.addEventListener('resize', getContainerHeight);
      if (wrapper.value?.parentNode) {
        wrapperObserver.observe(wrapper.value.parentNode, {
          attributes: true,
        });
      }

      if (props.showSender) {
        senderObserver.observe(sender.value, {
          childList: true,
          subtree: true,
        });
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', getContainerHeight);
      wrapperObserver.disconnect();
      if (props.showSender) {
        senderObserver.disconnect();
      }
    });

    return {
      wrapper,
      header,
      sender,
      containerHeight,
      roomId,
      mid,
    };
  },
});
</script>


<style lang="less" scoped>
.live-comment {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .comment-header-wrapper {
    font-size: 18px;
    color: #333;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
    flex: 0 0 auto;
    background: #fff;
    border-radius: 8px 8px 0 0;

    & > h2 {
      margin: 0;
      padding: 0;
      font-size: 18px;
      line-height: 22px;
    }
  }

  .comment-container-wrapper {
    flex-grow: 1;
    flex-shrink: 1;
    background: #fafafa;
    height: 100%;
  }

  .comment-sender-wrapper {
    padding: 12px 16px;
    flex-grow: 1;
    flex-shrink: 0;
    background: #fff;
    border-radius: 0 0 8px 8px;
  }
}
</style>